import { useStrictLocalization } from "@faire/web--source/common/localization";

export const useFormatTime = (milliseconds: number): string => {
  const { strictLocalize } = useStrictLocalization();
  if (milliseconds < 0) {
    return "";
  }

  const minutes = Math.floor(milliseconds / 60000);
  const hours = Math.floor(milliseconds / 3600000);

  if (hours > 1) {
    return strictLocalize(
      {
        defaultMessage: "{hoursTime} hours",
        description: { text: "Formatted display time, for example, 3 hours" },
      },
      { hoursTime: String(hours) }
    );
  } else if (hours === 1) {
    return strictLocalize({
      defaultMessage: "1 hour",
      description: { text: "Formatted display time, for example, 1 hour" },
    });
  } else if (minutes > 1) {
    return strictLocalize(
      {
        defaultMessage: "{minutesTime} minutes",
        description: {
          text: "Formatted display time, for example, 3 minutes",
        },
      },
      { minutesTime: String(minutes) }
    );
  } else if (minutes === 1) {
    return strictLocalize({
      defaultMessage: "1 minute",
      description: { text: "Formatted display time, for example, 1 minute" },
    });
  } else {
    return strictLocalize({
      defaultMessage: "3 minutes",
      description: { text: "Formatted display time" },
    });
  }
};
